import type { PointerEvent as ReactPointerEvent, RefObject } from 'react';

export interface ComboboxTriggerOptions {
  inputRef: RefObject<HTMLInputElement | null>;
  onOpen: () => void;
  shouldIgnore?: (target: HTMLElement) => boolean;
  canOpen?: () => boolean;
}

/** Opens combobox on pointer down; on touch avoids preventDefault so the virtual keyboard can appear. */
export function handleComboboxTriggerPointerDown(
  e: ReactPointerEvent<HTMLElement>,
  { inputRef, onOpen, shouldIgnore, canOpen }: ComboboxTriggerOptions,
): void {
  if (canOpen && !canOpen()) return;
  const target = e.target as HTMLElement;
  if (shouldIgnore?.(target)) return;

  if (e.pointerType === 'touch') {
    onOpen();
    if (!target.closest('input, textarea')) {
      requestAnimationFrame(() => inputRef.current?.focus());
    }
    return;
  }

  e.preventDefault();
  onOpen();
  inputRef.current?.focus();
}

/** Selects a combobox menu item; on mouse prevents blur before the handler runs. */
export function handleComboboxMenuItemPointerDown(
  e: ReactPointerEvent<HTMLElement>,
  onSelect: () => void,
): void {
  if (e.pointerType === 'touch') {
    onSelect();
    return;
  }
  e.preventDefault();
  onSelect();
}
